export default __webpack_public_path__ + "static/media/buy-white.9b6e6567.svg";